import { useMutation } from '@apollo/client';
import { gql } from '../graphql/generated/gql';

const UPDATE_EMAIL_MUTATION = gql(/** @complexity 2 */ `
  mutation updateUserEmail($id: ID!, $email: String!) {
    updateUser(id: $id, email: $email) {
      id
      email
    }
  }
`);

const useUpdateEmailMutation = () => {
  const [mutate] = useMutation(UPDATE_EMAIL_MUTATION);

  return (id: string, email: string) => mutate({ variables: { id, email } });
};

export default useUpdateEmailMutation;
